import React, { useContext, useEffect, useRef } from 'react'
import InputFieldV2 from '../../../lib/input/InputFieldV2';
import CribSheetList from '../createLocation/CribSheetList';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { createCribSheetFormData } from '../../../data/formData';
import { makePatchCall, makePostCall } from '../../../effects/requests';
import { endPoints } from '../../../utils/endpoints';
import { ApiResponseType } from '../../../types';
import { emptyFunction, getCompanyName, showToast } from '../../../utils';
import { MyContext } from '../../../context';

interface IUpdateCrib {
    onClose: () => void;
    onUpdate: () => void;
    cribData: any;
    cribEntries: Array<any>;
    onDelete: (data: any) => void;
    handleEdit: (data: any) => void;
    locationID: any
}

const UpdateCrib = (props: IUpdateCrib) => {

    const inputRef: any = useRef(null);

    const { userData } = useContext(MyContext)

    const methods = useForm({
        mode: 'all',
        defaultValues: { ...createCribSheetFormData() },
        reValidateMode: 'onBlur',
    });

    const onSubmit: SubmitHandler<any> = (data: any) => {
        if (props?.cribData?.id) {
            updateCrib(data);
        } else (
            createCrib(data)
        )
    };

    const updateCrib = (data: any) => {
        const url = `${endPoints.LOCATION_CRIB}${props?.cribData?.id}/`
        makePatchCall(url, data).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message || '', 'success')
                props?.onUpdate();
            }
        }).catch(emptyFunction)
    }

    const createCrib = (payload: any) => {
        const apiPayload = {
            location_id: props?.locationID,
            headline: payload?.headline || '',
            description: payload?.description || '',
            production_company_name: getCompanyName(userData),
        }
        makePostCall(endPoints.LOCATION_CRIB, apiPayload).then((res: ApiResponseType<any>) => {
            if (res?.status?.code === 200) {
                showToast(res?.status?.message || '', 'success')
                props?.onUpdate();
            }
        }).catch(emptyFunction);
    }

    useEffect(() => {
        if (props?.cribData?.id) {
            methods.reset({
                headline: props?.cribData?.headline,
                description: props?.cribData?.description,
            });
        }
        inputRef.current?.focus();
    }, [props?.cribData?.id])

    return (
        <div>
            <div className="lcs-backdrop" onClick={props.onClose} />
            <div className="lcs-edit-drawer">
                <div className="lcs-edit-drawer__header">
                    <button className="lcs-edit-drawer__close" onClick={props.onClose}>
                        <img src='/assets/images/dismiss.svg' alt='close' />
                    </button>
                    <h2 className="lcs-edit-drawer__title">Edit Crib Sheet</h2>
                </div>

                <div className="lcs-edit-drawer__body">
                    <CribSheetList
                        entries={props?.cribEntries}
                        setDeleteEntry={(entry, idx) => props?.onDelete?.(entry)}
                        setEditEntry={props?.handleEdit}
                        itemStyle={{ marginBottom: 8 }}
                    />
                    <div className="cl-step__fields">
                        <FormProvider {...methods}>
                            <InputFieldV2
                                ref={inputRef}
                                name="headline"
                                label="Headline"
                                placeholder="Enter Headline"
                                type="text"
                                rules={{
                                    required: "Headline is required",
                                }}
                            />

                            <InputFieldV2
                                name="description"
                                label="Description"
                                placeholder="Enter Description"
                                type="text"
                                rules={{
                                    required: "Description is required",
                                }}
                                isTextArea
                                maxLength={10000}
                            />
                        </FormProvider>
                    </div>
                </div>

                <div className="lcs-edit-drawer__footer">
                    <button className="lcs-edit-drawer__save-update" onClick={methods.handleSubmit(onSubmit)}>
                        Save &amp; Update
                    </button>
                </div>
            </div>
        </div>
    )
}

export default UpdateCrib